import { cn } from "@web/lib/utils.ts";

export function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      className={cn("animate-pulse rounded-md bg-panel-elevated", className)}
      {...props}
    />
  );
}
